export const drawingSource = [
  "/assets/images/art/IMG_1.jpg",
  "/assets/images/art/IMG_2.jpg",
  "/assets/images/art/IMG_3.jpg",
  "/assets/images/art/IMG_4.jpg",
  "/assets/images/art/IMG_5.jpg",
  "/assets/images/art/IMG_6.jpg",
  "/assets/images/art/IMG_7.jpg"
];
